import { render, staticRenderFns } from "./DocumentDetection.vue?vue&type=template&id=4109a9ba&"
import script from "./DocumentDetection.vue?vue&type=script&lang=js&"
export * from "./DocumentDetection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports